import micIcon from "../../assets/icons/mic.svg";
import sendIcon from "../../assets/icons/send.svg";
import { emit } from "../../core/state.js";
import { getTheme, getUiFeature } from "../../core/configAccessors.js";
import { speech } from "../../services/speech.js";

const DEFAULT_PLACEHOLDER = "Ask me anything...";
const LISTENING_PLACEHOLDER = "I am listening...";

export default class InputBar {
  render() {
    const inputArea = document.createElement("div");
    inputArea.className = "ws-input-area";

    const inputWrap = document.createElement("div");
    inputWrap.className = "ws-input-wrap";

    const input = document.createElement("input");
    input.className = "ws-input";
    input.type = "text";
    input.placeholder = DEFAULT_PLACEHOLDER;
    inputWrap.appendChild(input);

    const showMic = getUiFeature("show_mic", true) && speech.isAvailable();

    // Tracks whether the current input value came from speech. Set when
    // speech.onResult populates the input; cleared on any user keystroke or
    // after a submit. Sent to the BE on the next request (used_stt) — parity
    // with old script.js where used_stt = true is set on first STT recognition.
    let usedStt = false;

    let micBtn = null;
    if (showMic) {
      micBtn = document.createElement("button");
      micBtn.type = "button";
      micBtn.className = "ws-btn-mic";
      micBtn.title = "Voice input";
      const micIconUrl = getTheme("mic_icon_url", null);
      if (micIconUrl) {
        const img = document.createElement("img");
        img.src = micIconUrl;
        img.alt = "";
        micBtn.appendChild(img);
      } else {
        micBtn.innerHTML = micIcon;
      }
      inputWrap.appendChild(micBtn);
    }

    const sendBtn = document.createElement("button");
    sendBtn.type = "button";
    sendBtn.className = "ws-btn-send";
    sendBtn.title = "Send";
    sendBtn.innerHTML = sendIcon;

    const submit = () => {
      const text = input.value.trim();
      if (!text) return;
      input.value = "";
      const wasStt = usedStt;
      usedStt = false;
      emit("ws-chat-input-submit", { text, usedStt: wasStt });
    };

    sendBtn.addEventListener("click", submit);
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        submit();
        return;
      }
      // Any user keystroke other than Enter means the user is editing the
      // text themselves — no longer purely an STT-originated message.
      // Speech.onResult writes to input.value programmatically and does NOT
      // fire keydown, so this only clears the flag for real keyboard input.
      usedStt = false;
    });

    if (micBtn) {
      const setListeningUI = (on) => {
        micBtn.classList.toggle("ws-btn-mic--listening", on);
        input.placeholder = on ? LISTENING_PLACEHOLDER : DEFAULT_PLACEHOLDER;
      };

      micBtn.addEventListener("click", () => {
        if (speech.isListening()) {
          speech.stop();
          return;
        }

        const started = speech.start({
          onResult: (transcript, isFinal) => {
            input.value = transcript;
            usedStt = true; // mark for the next ws-chat-input-submit
            if (isFinal) {
              speech.stop();
            }
          },
          onEnd: () => setListeningUI(false),
          onError: (err) => {
            console.warn("[RedConcierge] Speech error:", err);
            setListeningUI(false);
          },
        });
        if (started) setListeningUI(true);
      });
    }

    inputArea.appendChild(inputWrap);
    inputArea.appendChild(sendBtn);

    return inputArea;
  }
}
